/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';
import * as luxon from 'luxon';

import { SharedAdviseLocationI } from '../../api/shared-advise-location/shared-advise-location.result.int';
import * as actions from './shared-advise-location.actions';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';

interface StateObjectI {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: SharedAdviseLocationI;
    receivedTime: string;
}

export interface State {
    [SharedPageTypeEnum.ordDetails]: StateObjectI;
    [SharedPageTypeEnum.infCnt]: StateObjectI;
    [SharedPageTypeEnum.quaDischarge]: StateObjectI;
    [SharedPageTypeEnum.quaRelocate]: StateObjectI;
}

export const initialState: State = {
    [SharedPageTypeEnum.ordDetails]: {
        error: null,
        loaded: false,
        loading: false,
        data: null,
        receivedTime: null,
    },
    [SharedPageTypeEnum.infCnt]: {
        error: null,
        loaded: false,
        loading: false,
        data: null,
        receivedTime: null,
    },
    [SharedPageTypeEnum.quaDischarge]: {
        error: null,
        loaded: false,
        loading: false,
        data: null,
        receivedTime: null,
    },
    [SharedPageTypeEnum.quaRelocate]: {
        error: null,
        loaded: false,
        loading: false,
        data: null,
        receivedTime: null,
    },
};

export default createFeature({
  name: 'sharedAdviseLocation',
  reducer: createReducer(
    initialState,
    on(actions.error, (state: State, { pageType, messageText }): State => ({
        ...state,
        [pageType]: {
            ...state[pageType],
            error: messageText,
            loaded: false,
            loading: false
        }
    })),
    on(actions.reset, (state: State, { pageType }): State => ({
        ...state,
        [pageType]: {
            ...state[pageType],
            data: null,
            error: null,
            loaded: false,
            loading: false
        }
    })),
    on(actions.received, (state: State, { result, pageType }): State => ({
        ...state,
        [pageType]: {
            ...state[pageType],
            data: result,
            error: null,
            loaded: true,
            loading: false,
            receivedTime: luxon.DateTime.now().toISO(),
        }
    })),
    on(actions.load, (state: State, { pageType }): State => ({
        ...state,
        [pageType]: {
            ...state[pageType],
            loaded: false,
            loading: true
        }
    }))
  )}
);